var map = {
	"./:collectionName": [
		317,
		0,
		4
	],
	"./:collectionName/": [
		317,
		0,
		4
	],
	"./:collectionName/:id": [
		314,
		1
	],
	"./:collectionName/:id/": [
		314,
		1
	],
	"./:collectionName/:id/index": [
		314,
		1
	],
	"./:collectionName/:id/index.js": [
		314,
		1
	],
	"./:collectionName/duplicate/:id": [
		315,
		2
	],
	"./:collectionName/duplicate/:id/": [
		315,
		2
	],
	"./:collectionName/duplicate/:id/index": [
		315,
		2
	],
	"./:collectionName/duplicate/:id/index.js": [
		315,
		2
	],
	"./:collectionName/index": [
		317,
		0,
		4
	],
	"./:collectionName/index.js": [
		317,
		0,
		4
	],
	"./:collectionName/new": [
		313,
		3
	],
	"./:collectionName/new/": [
		313,
		3
	],
	"./:collectionName/new/index": [
		313,
		3
	],
	"./:collectionName/new/index.js": [
		313,
		3
	],
	"./:collectionName/singleton": [
		316,
		5
	],
	"./:collectionName/singleton/": [
		316,
		5
	],
	"./:collectionName/singleton/index": [
		316,
		5
	],
	"./:collectionName/singleton/index.js": [
		316,
		5
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 1298;
module.exports = webpackAsyncContext;